module.exports = function() {
  return new Worker(__webpack_public_path__ + "c266df9893ebd9202cf1.worker.js");
};